module.exports = __webpack_public_path__ + "static/media/logo-dark.06d7e12e.svg";